import { render } from "./CanvasSelectedContent.vue?vue&type=template&id=60834e23&scoped=true&ts=true"
import script from "./CanvasSelectedContent.vue?vue&type=script&lang=ts"
export * from "./CanvasSelectedContent.vue?vue&type=script&lang=ts"

import "./CanvasSelectedContent.vue?vue&type=style&index=0&id=60834e23&lang=scss&scoped=true"

import exportComponent from "/Users/martjan/repositories/q-42/virtueel-indisch-monument/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60834e23"]])

export default __exports__